import axios from "axios";
import { useEffect, useMemo, useState } from "react";
import styles from "./AdminDashboard.module.css";

// ✅ Chart.js imports
import {
  ArcElement,
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
} from "chart.js";
import { Doughnut, Line } from "react-chartjs-2";

// Register chart components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  LineElement,
  PointElement
);

const AdminDashboard = () => {
  const [totalVendors, setTotalVendors] = useState(0);
  const [totalSubowners, setTotalSubowners] = useState(0);

  const url = "https://prod.toxboxai.com";

  useEffect(() => {
    const token = localStorage.getItem("token");

    const fetchVendors = async () => {
      try {
        const response = await axios.get(`${url}/api/owner/vendors`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setTotalVendors(response.data.count || 0);
      } catch (error) {
        console.error("Error fetching vendors:", error);
      }
    };

    const fetchSubowners = async () => {
      try {
        const res = await axios.get(`${url}/api/owner/subowners`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setTotalSubowners(res.data.count || 0);
      } catch (err) {
        console.error("Error fetching subowners:", err);
      }
    };

    fetchVendors();
    fetchSubowners();
  }, []);

  // ✅ Chart Data (Dynamic)
  const revenueData = useMemo(
    () => ({
      labels: ["Vendors", "Subowners", "Business", "Recharge"],
      datasets: [
        {
          label: "Count",
          data: [totalVendors, totalSubowners, 15, 2500],
          backgroundColor: ["#4A90E2", "#50E3C2", "#F5A623", "#D0021B"],
          borderRadius: 6,
        },
      ],
    }),
    [totalVendors, totalSubowners]
  );

  const moneySpentData = useMemo(
    () => ({
      labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"],
      datasets: [
        {
          label: "Money Spent",
          data: [500, 800, 600, 1200, 900, 1500], //  Replace with API later
          borderColor: "#4A90E2",
          backgroundColor: "rgba(74, 144, 226, 0.2)",
          fill: true,
          tension: 0.4,
        },
      ],
    }),
    []
  );

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: { position: "top" },
      title: { display: false },
    },
  };

  return (
    <div className={styles.admindashboardContainer}>
      {/* Top Stats Cards */}
      <div className={styles.statsContainer}>
        <div className={styles.card}>
          <div className={styles.iconCircle}>🏪</div>
          <div>
            <h2>{totalVendors}</h2>
            <p>Total Vendors</p>
          </div>
        </div>

        <div className={styles.card}>
          <div className={styles.iconCircle}>👥</div>
          <div>
            <h2>{totalSubowners}</h2>
            <p>Total Subowners</p>
          </div>
        </div>

        <div className={styles.card}>
          <div className={styles.iconCircle}>📣</div>
          <div>
            <h2>15</h2>
            <p>Total Business</p>
          </div>
        </div>

        <div className={styles.card}>
          <div className={styles.iconCircle}>💳</div>
          <div>
            <h2>2500</h2>
            <p>Total Recharge</p>
          </div>
        </div>
      </div>

      {/* Insights Section */}
      <div className={styles.insightsSection}>
        <h2>Insights</h2>
        <div className={styles.insightsGrid}>
          {/* Revenue Chart */}
          <div className={styles.insightBox}>
            <h3>Revenue Generated</h3>
            <div className={styles.chartContainer}>
              <Doughnut
                data={revenueData}
                options={{
                  responsive: true,
                  maintainAspectRatio: false, // 👈 stretch to container
                  plugins: {
                    legend: { position: "top" },
                  },
                }}
              />
            </div>
          </div>

          {/* Money Spent Chart */}
          <div className={styles.insightBox}>
            <h3>Money Spent</h3>
            <div className={styles.chartContainer}>
              <Line
                data={moneySpentData}
                options={{ ...chartOptions, maintainAspectRatio: false }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
